module.exports = __webpack_public_path__ + "img/img04.5ebc0cc3.png";